export default __webpack_public_path__ + "static/media/sch6_w320.5d56f704.jpg";